export const NO_HIT = "NO_HIT";
export const BOUNDARY = "BOUNDARY";
export const HIT = "HIT";

export const RECEIVE_DATA = "RECEIVE_DATA";
export const MOUSE_DOWN = "MOUSE_DOWN";
export const MOUSE_UP = "MOUSE_UP";
export const MOUSE_MOVE = "MOUSE_MOVE";
export const MOUSE_LEAVE = "MOUSE_LEAVE";
export const MOUSE_CLICK = "MOUSE_CLICK";
export const SAVING = "SAVING";
export const SAVED = "SAVED";
export const DELETING = "DELETING";
export const DELETED = "DELETED";
export const CHANGE_COLOR = "CHANGE_COLOR";
export const CHANGE_DATE = "CHANGE_DATE";
export const CHANGE_INFO = "CHANGE_INFO";
export const DELETE_ITEM = "DELETE_ITEM";
export const RESIZE_ROW = "RESIZE_ROW";
export const SET_RANGE = "SET_RANGE";
export const DESELECT = "DESELECT";

export const MODE_NONE = "MODE_NONE";
export const MODE_MOVE = "MODE_MOVE";
export const MODE_CREATE = "MODE_CREATE";
export const MODE_RESIZE_TOP = "MODE_RESIZE_TOP";
export const MODE_RESIZE_BOTTOM = "MODE_RESIZE_BOTTOM";
export const MODE_EDIT = "MODE_EDIT";

export const STATUS_UNSAVED = "STATUS_UNSAVED";
export const STATUS_DELETED = "STATUS_DELETED";
export const STATUS_DELETING = "STATUS_DELETING";
export const STATUS_SAVING = "STATUS_SAVING";
export const STATUS_SAVED = "STATUS_SAVED";
export const STATUS_CREATING = "STATUS_CREATING";
